import { Descriptions, Modal, Tag } from "antd";
import LabeledInput from "../ui/LabeledInput";
import LabeledDropdown from "../ui/Dropdown";
import { Space, Typography } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
const { Text } = Typography;

const ManageSubscriptionModal = ({
  visible,
  onCancel,
  onSubmit,
  formData,
  setFormData,
}) => {
  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <Modal
      title="Manage Subscription"
      visible={visible}
      onCancel={onCancel}
      onOk={onSubmit}
      okText="Update"
      width={700}
    >
      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Descriptions bordered size="small">
            <Descriptions.Item label="Name">
              {formData.name || "N/A"}
            </Descriptions.Item>
          </Descriptions>

          <Tag icon={<CheckCircleOutlined />} color="success">
            {" "}
            {formData.status}{" "}
          </Tag>
        </div>
        {/* Two per row */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <LabeledInput
            label="Start Date"
            value={formData.start_date}
            onChange={(e) => handleChange("start_date", e.target.value)}
          />
          <LabeledInput
            label="End Date"
            value={formData.end_date}
            onChange={(e) => handleChange("end_date", e.target.value)}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
          <LabeledDropdown
            label="Subscription Type"
            options={[
              { value: "Trial", label: "TRIAL" },
              { value: "Annual", label: "ANNUAL" },
            ]}
            value={formData.status}
            onChange={(val) => handleChange("status", val)}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ManageSubscriptionModal;
